import { FunctionComponent, ReactElement } from 'react';
import { Site } from '@/core/entities';
import { Stack } from '@mui/material';

const MainPointOfContactCell: FunctionComponent<
	Pick<Site, 'siteAdminName' | 'siteAdminEmail' | 'siteAdminTitle'>
> = ({ siteAdminName, siteAdminEmail, siteAdminTitle }): ReactElement => (
	<Stack direction="column">
		<span>
			{siteAdminName} {siteAdminTitle && `(${siteAdminTitle})`}
		</span>
		<span>{siteAdminEmail}</span>
	</Stack>
);

export default MainPointOfContactCell;
